






















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { mapState } from "vuex";
import BasicMobileFullModal from '~/components/modals/BasicMobileFullModal.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';
import RoutesCitiesDropdown from '~/components/partials/RoutesCitiesDropdown.vue';
import RoutesDifficultyDropdown from '~/components/partials/RoutesDifficultyDropdown.vue';
import CheckBoxesDropdown from '~/components/partials/CheckBoxesDropdown.vue';
import LabelsPicker from "~/components/partials/LabelsPicker.vue";
import SportsDropdown from "~/components/partials/SportsDropdown.vue";
import { shouldShowSportsDropdown } from "~/utils/routes";

@Component({
  components: { SportsDropdown, LabelsPicker, BasicMobileFullModal, CheckInput, RoutesCitiesDropdown, RoutesDifficultyDropdown, CheckBoxesDropdown },
  computed: {
    ...mapState([
      'iframeMode',
    ]),
  },
})
export default class LocalisationRoutesMobileModal extends Vue {
  @Prop({ type: Array, default: () => [] }) value : Array<number | string>;
  @Prop(String) departureSelected: '';
  @Prop(Boolean) closedRoutes: false;
  @Prop(Array) difficultyFilters: [];
  @Prop(Array) difficultyElevation: [];
  @Prop(Array) difficultyDistance: [];
  @Prop(Array) cities: [];
  @Prop(Array) labels: [];
  @Prop(Array) sports: [];

  declare iframeMode: boolean;

  @Watch('value')
  watch () {
    this.$emit('input', this.value);
  }

  get shouldShowSportsDropdown (): boolean {
    return shouldShowSportsDropdown(this.iframeMode, this.value);
  }
}
